import { LocalDate } from '@js-joda/core';

import { TextView } from '@dreryk/react-components';
import { dateTimeMinuteFormatter } from '@dreryk/react-common';

import { translationKeys } from '../translations';

type AppointmentBeginDateTextViewProps = Readonly<{ beginDate: LocalDate | Date }>;

export const AppointmentBeginDateTextView = (props: AppointmentBeginDateTextViewProps): JSX.Element => {
   return (
      <TextView testId={'beginDate'} label={translationKeys.appointmentBeginDate}>
         {dateTimeMinuteFormatter(props.beginDate)}
      </TextView>
   );
};
